import { useEffect, useState } from "react";
import {
    Card,
    Col,
    Row,
    Typography,
    Tooltip,
    Select,
    DatePicker,
    Form,
    theme,
    Button
} from "antd";
import {
    SearchOutlined,
} from "@ant-design/icons";
import Echart from "../../components/chart/EChart";
import { Images } from "../../assets";
import dayjs from "dayjs";
import LoadingBase from "../../components/LoadingBase";
import { consoleLogUtil } from "../../utils/consoleLogUtil";
import { filterOption, formatNumber } from "../../utils/funcHelper";
import { useSelector } from "react-redux";
import { get_daily_revenue, get_dashboard_summary, getListBranches } from "../../services/apis";

const { Title } = Typography;

const { RangePicker } = DatePicker;

const DATA_DEFAULT = {
    top: [
        {
            key: "gmv",
            today: 0,
            title: "DOANH THU DỊCH VỤ",
            persent: 0,
            icon: Images.ic_shift,
            bnb: "bnb2",
            classBox: "icon-box",
            toolTip: "Tổng doanh thu bán dịch vụ trong khoảng thời gian."
        },
        {
            key: "orders",
            today: 0,
            title: "THU DỊCH VỤ THỰC TẾ",
            persent: 0,
            icon: Images.ic_order,
            bnb: "bnb2",
            classBox: "icon-box",
            toolTip: "Tổng thu dịch vụ thực tế trong khoảng thời gian."
        },
        {
            key: "buyers",
            today: 0,
            title: "THU CÔNG NỢ",
            persent: 0,
            icon: Images.ic_customer,
            bnb: "bnb2",
            classBox: "icon-box",
            toolTip: "Tổng thu công nợ trong khoảng thời gian."
        },
        {
            key: "aov",
            today: 0,
            title: "THU BÁN SẢN PHẨM",
            persent: 0,
            icon: Images.ic_average,
            bnb: "bnb2",
            classBox: "icon-box",
            toolTip: "Tổng doanh thu bán sản phẩm trong khoảng thời gian."
        }
    ],
    right: [
        {
            key: "waiting",
            today: 0,
            prev: 0,
            title: "TỔNG THU THỰC TẾ",
            persent: 0,
            icon: Images.ic_waiting,
            bnb: "bnb2",
            classBox: "icon-box",
            toolTip: "Tổng doanh thu thực tế trong khoảng thời gian."
        },
        {
            key: "processing",
            today: 0,
            prev: 0,
            title: "KHÁCH HÀNG MỚI",
            persent: 0,
            icon: Images.ic_process,
            bnb: "bnb2",
            classBox: "icon-box",
            toolTip: "Số khách hàng mới đến đăng ký dịch vụ"
        },
        {
            key: "completed",
            today: 0,
            prev: 0,
            title: "KH CŨ LÀM DỊCH VỤ",
            persent: 0,
            icon: Images.ic_completed,
            bnb: "bnb2",
            classBox: "icon-box",
            toolTip: "Số khách hàng cũ quay lại làm dịch vụ"
        },
        {
            key: "cancelled",
            today: 0,
            prev:  0,
            title: "DỊCH VỤ HỦY",
            persent: 0,
            icon: Images.ic_canceled,
            bnb: "redtext",
            classBox: "icon-box",
            toolTip: "Số dịch vụ bị hủy trong khoảng thời gian."
        }
    ]
};


const DashboardPage = () => {
    const [dataChart, setDataChart] = useState([]);
    const [dataTop, setDataTop] = useState(DATA_DEFAULT.top);
    const [dataRight, setDataRight] = useState(DATA_DEFAULT.right);
    const [loading, setLoading] = useState(false);
    const [branches, setBranches] = useState([]);
    const { token } = theme.useToken();
    const [form] = Form.useForm();
    const userReducer = useSelector((state) => state?.userReducer?.data);

    const initialValues = {
        date: [dayjs().subtract(7, 'day').startOf('day'), dayjs().endOf('day')]
    };
    const formStyle = {
        maxWidth: 'none',
        background: 'white',
        borderRadius: token.borderRadiusLG,
        paddingLeft: 0,
        paddingRight: 0,
        marginBottom: 0,
    };
    const mapPerformanceToData = (apiData) => {
        if (!apiData) return { top: [], right: [] };

        return {
            top: [
                {
                    key: "gmv",
                    today: apiData?.total_service_estimated ? formatNumber(apiData?.total_service_estimated, 0) : 0,
                    title: "DOANH THU DỊCH VỤ",
                    persent: 0,
                    icon: Images.ic_shift,
                    bnb: "bnb2",
                    classBox: "icon-box",
                    toolTip: "Tổng doanh thu bán dịch vụ trong khoảng thời gian."
                },
                {
                    key: "orders",
                    today: apiData?.total_service_paid ? formatNumber(apiData?.total_service_paid, 0) : 0,
                    title: "THU DỊCH VỤ THỰC TẾ",
                    persent: 0,
                    icon: Images.ic_order,
                    bnb: "bnb2",
                    classBox: "icon-box",
                    toolTip: "Tổng thu dịch vụ thực tế trong khoảng thời gian."
                },
                {
                    key: "buyers",
                    today: apiData?.total_debt_payment ? formatNumber(apiData?.total_debt_payment, 0) : 0,
                    title: "THU CÔNG NỢ",
                    persent: 0,
                    icon: Images.ic_customer,
                    bnb: "bnb2",
                    classBox: "icon-box",
                    toolTip: "Tổng thu công nợ trong khoảng thời gian."
                },
                {
                    key: "aov",
                    today: apiData?.total_product_revenue ? formatNumber(apiData?.total_product_revenue, 0) : 0,
                    title: "THU BÁN SẢN PHẨM",
                    persent: 0,
                    icon: Images.ic_average,
                    bnb: "bnb2",
                    classBox: "icon-box",
                    toolTip: "Tổng doanh thu bán sản phẩm trong khoảng thời gian."
                }
            ],
            right: [
                {
                    key: "waiting",
                    today: apiData?.total_revenue ? formatNumber(apiData?.total_revenue, 0) : 0,
                    prev: 0,
                    title: "TỔNG THU THỰC TẾ",
                    persent: 0,
                    icon: Images.ic_waiting,
                    bnb: "bnb2",
                    classBox: "icon-box",
                    toolTip: "Tổng doanh thu thực tế trong khoảng thời gian."
                },
                {
                    key: "processing",
                    today: apiData?.total_customers ? formatNumber(apiData?.total_customers, 0) : 0,
                    prev: 0,
                    title: "KH ĐĂNG KÝ MỚI",
                    persent: 0,
                    icon: Images.ic_process,
                    bnb: "bnb2",
                    classBox: "icon-box",
                    toolTip: "Số khách hàng mới đến đăng ký dịch vụ"
                },
                {
                    key: "completed",
                    today: apiData?.total_service_customers ? formatNumber(apiData?.total_service_customers, 0) : 0,
                    prev: 0,
                    title: "KH CŨ LÀM DỊCH VỤ",
                    persent: 0,
                    icon: Images.ic_completed,
                    bnb: "bnb2",
                    classBox: "icon-box",
                    toolTip: "Số khách hàng cũ quay lại làm dịch vụ"
                },
                {
                    key: "cancelled",
                    today: apiData?.total_services_cancelled ? formatNumber(apiData?.total_services_cancelled, 0) : 0,
                    prev:  0,
                    title: "DỊCH VỤ BỊ HỦY",
                    persent: 0,
                    icon: Images.ic_canceled,
                    bnb: "redtext",
                    classBox: "icon-box",
                    toolTip: "Số dịch vụ bị hủy trong khoảng thời gian."
                }
            ]
        };
    };

    const getDataBranches = async () => {
        try {
            const params = {
                keyword: '',
            }
            const res = await getListBranches(params);
            if (res && res.status === 1) {
                setBranches([...res?.data?.data?.map(item => ({
                    value: item.id,
                    label: item.name
                }))
                ]);
            } else {
                setBranches([]);
            }
        } catch (error) {
            console.log('error', error);
        }
        

    }

    const getDataChart = async (branch_ids, from_date, to_date) => {
        try {
            const params = {
                branch_ids: branch_ids,
                start_date: from_date,
                end_date: to_date
            }
            const res = await get_daily_revenue(params);
            consoleLogUtil("getDataChart", res);
            if (res && res.status === 1) {
                setDataChart(res?.data?.data || []);
            } else {
                setDataChart([]);
            }
        } catch (error) {
            consoleLogUtil("getDataChart error", error);
        }
        
    }

    const getDataDashboard = async (branch_ids, start_date, end_date) => {
        const params = {
            branch_ids: branch_ids,
            start_date: start_date,
            end_date: end_date
        }
        const res = await get_dashboard_summary(params);
        consoleLogUtil("getDataDashboard", res);
        if (res && res.status === 1) {
            const mappedData = mapPerformanceToData(res?.data?.summary);
            consoleLogUtil("mappedData", mappedData);
            setDataTop(mappedData.top);
            setDataRight(mappedData.right);
        } else {
            setDataTop(DATA_DEFAULT.top);
            setDataRight(DATA_DEFAULT.right);
        }
    }
    const callAPIDashboard = (branch_ids, from_date, to_date) => {
        setLoading(true);
        Promise.all([getDataChart(branch_ids, from_date, to_date), getDataDashboard(branch_ids, from_date, to_date)])
        .finally(() => setLoading(false));
    }
    const getUnitByIndex = (index) => {
        switch (index) {
            case 0:
            case 3:
                return "vnđ"; // Đơn vị cho index = 0 và index = 3
            case 1:
                return "vnđ"; // Đơn vị cho index = 1
            case 2:
                return "vnđ"; // Đơn vị cho index = 2
            default:
                return ""; // Không có đơn vị cho các trường hợp khác
        }
    };
    const getUnitRow2ByIndex = (index) => {
        switch (index) {
            case 0:
                return "vnđ"; // Đơn vị cho index = 0
            case 1:
            case 2: 
            case 3:   
                return ""; // Đơn vị cho index = 0 và index = 1
            default:
                return ""; // Không có đơn vị cho các trường hợp khác
        }
    };


    const onFinish = async (dataForm) => {
        const branch_ids = dataForm?.branch_ids;
        const from_date = dataForm?.date ? dataForm.date[0].format('YYYY-MM-DD') : null;
        const to_date = dataForm?.date ? dataForm.date[1].format('YYYY-MM-DD') : null;
        callAPIDashboard(branch_ids, from_date, to_date);
    };
    useEffect(() => {

        getDataBranches();

    }, []);
    useEffect(() => {
        const branch_ids = form.getFieldValue('branch_ids');
        const from_date = initialValues.date[0].format('YYYY-MM-DD');
        const to_date = initialValues.date[1].format('YYYY-MM-DD');
        callAPIDashboard(branch_ids, from_date, to_date);
    }, []);
    return (
        <div className="layout-content">
            <Form form={form} name="advanced_search" style={formStyle} onFinish={onFinish} initialValues={initialValues}>
                <Row gutter={24}>
                    <Col span={6}>
                        <Form.Item
                            name="branch_ids"
                        >
                            <Select
                                mode="multiple"
                                maxTagCount={'responsive'}
                                showSearch
                                placeholder={'Chọn cơ sở'}
                                style={{ width: '100%', height: 40 }}
                                defaultActiveFirstOption={false}
                                filterOption={filterOption}
                                notFoundContent={null}
                                options={branches}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            name="date"
                            rules={[{ required: true, message: 'Vui lòng chọn ngày!' }]}
                        >
                            <RangePicker
                                allowClear={false}
                                style={{ width: '100%', height: 40 }}
                                format={"DD/MM/YYYY"}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={3}>
                        <Tooltip title="Xem số liệu">
                            <Button type="primary" htmlType="submit">
                                <SearchOutlined />
                            </Button>
                        </Tooltip>
                    </Col>
                </Row>
            </Form>
            {/* Top cards */}
            <Row className="rowgap-vbox" gutter={[24, 0]}>
                {dataTop?.map((c, index) => (
                    <Col key={index} xs={24} sm={24} md={12} lg={6} xl={6} className="mb-24">
                        <Card bordered={false} className="criclebox ">
                            <div className="number">
                                <Row align="middle" gutter={[24, 0]}>
                                    <Col xs={18}>
                                        <span>{c.title}</span>
                                        <Tooltip placement="top" title={c.toolTip}>
                                            <Title level={4}>
                                                {c.today} {<small className="txt-unit">{getUnitByIndex(index)}</small>}
                                            </Title>
                                        </Tooltip>
                                    </Col>
                                    <Col xs={6} style={{ display: "flex", alignItems: "center", flexDirection: "column" }}>
                                        {/* <Tooltip placement="top" title={"Tăng/giảm so với cùng kỳ trước"}>
                                            <div className="box-icon-chart">
                                                {c.persent > 0 ? <RiseOutlined style={{ color: "#52c41a" }} /> : (c.persent < 0 ? <FallOutlined style={{ color: "red" }} /> : null)}
                                                <small className={c.bnb}>{`${c.persent}%`}</small>
                                            </div>
                                        </Tooltip> */}
                                        <div className={c.classBox}><img src={c.icon} className="img-db" /></div>
                                    </Col>
                                </Row>
                            </div>
                        </Card>
                    </Col>
                ))}
            </Row>
            <Row gutter={[24, 0]}>
                {dataRight?.map((c, index) => (
                    <Col key={index} xs={24} sm={24} md={12} lg={6} xl={6} className="mb-24">
                        <Card bordered={false} className="criclebox ">
                            <div className="number">
                                <Row align="middle" gutter={[24, 0]}>
                                    <Col xs={18}>
                                        <span>{c.title}</span>
                                        <Tooltip placement="top" title={c.toolTip}>
                                            <Title level={4}>{c.today} <small>{getUnitRow2ByIndex(index)}</small></Title>
                                        </Tooltip>
                                    </Col>
                                    <Col xs={6} style={{ display: "flex", alignItems: "center", flexDirection: "column" }}>
                                        {/* <Tooltip placement="top" title="Tăng/giảm so với cùng kỳ trước">
                                            <div className="box-icon-chart">
                                                {c.persent > 0 ? <RiseOutlined style={{ color: "#52c41a" }} /> : (c.persent < 0 ? <FallOutlined style={{ color: "red" }} /> : null)}
                                                <small className={c.bnb}>{index === 2 ? `-` : `${c.persent}%`}</small>
                                            </div>
                                        </Tooltip> */}
                                        <div className={c.classBox}><img src={c.icon} className="img-db" /></div>
                                    </Col>
                                </Row>
                            </div>
                        </Card>
                    </Col>
                ))}
            </Row>
            {/* Chart + Complete List */}
            <Row gutter={[24, 0]}>
                <Col xs={24} sm={24} lg={24} xl={24} className="mb-24">
                    <Card bordered={false} className="criclebox h-full">
                        <Echart options={{
                            xaxis: { categories: dataChart?.map(item => dayjs(item.date).format("DD/MM")) }
                        }} series={[
                            { name: "Thu dịch vụ", data: dataChart?.map(item => item.service_actual), color: "#1200dc", type: 'column' },
                            { name: "Thu nợ", data: dataChart?.map(item => item.debt_payment), color: "#bfdc00", type: 'column' },
                            { name: "Thu bán sp", data: dataChart?.map(item => item.product_revenue), color: "#dc8800", type: 'column' },
                            { name: "Tổng thu", data: dataChart?.map(item => item.total_revenue), color: "#dc2800", type: 'line' }
                        ]} />
                    </Card>
                </Col>
                <Col xs={24} sm={12} lg={12} xl={12} className="mb-24">

                </Col>
            </Row>
            <LoadingBase loading={loading} />
        </div>
    );
};

export default DashboardPage;
